import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "./StandardPractices.css";
import Footer from "../Home/Footer";
import SoilPreparationImage from "../assets/img/SoilPrepration.jpg";
import SeedSelectionSowingImage from "../assets/img/SeedSelection&Sowing.jpg";
import FertilizationNutrientManagementImage from "../assets/img/Fertilization&NutrientManagement.jpg";
import IrrigationWaterManagementImage from "../assets/img/Irrigation&WaterManagement.jpg";
import PestDiseaseControlImage from "../assets/img/Pest&DiseaseControl.jpg";
import HarvestingStorageImage from "../assets/img/Harvesting&Storage.jpg";
import AboutUsSlider1 from "../assets/img/AboutUsSlider1.png";
import AboutUsSlider2 from "../assets/img/AboutUsSlider2.png";
import AboutUsSlider3 from "../assets/img/AboutUsSlider3.png";

const StandardPractices = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // Sample Data for Carousel Images
  const carouselData = [
    {
      id: 1,
      image: AboutUsSlider1,
      title: "Pulses: The Powerhouse Crops",
      description:
        "Explore the varieties, benefits, and market insights of pulses.",
    },
    {
      id: 2,
      image: AboutUsSlider2,
      title: "High Yield & Sustainability",
      description:
        "Pulses provide a rich source of protein and are a vital part of global agriculture.",
    },
    {
      id: 3,
      image: AboutUsSlider3,
      title: "Versatile Applications",
      description:
        "From food to feed, pulses play a crucial role in multiple industries.",
    },
  ];

  // Sample Data for Practices
  const practices = [
    {
      id: 1,
      title: "Soil Preparation",
      description:
        "Ensure well-drained soil with proper pH balance for better root growth.",
      image: SoilPreparationImage,
    },
    {
      id: 2,
      title: "Seed Selection & Sowing",
      description:
        "Choose high-yield pulse seeds and follow optimal sowing depth and spacing.",
      image: FertilizationNutrientManagementImage,
    },
    {
      id: 3,
      title: "Fertilization & Nutrient Management",
      description:
        "Use nitrogen-fixing bacteria and appropriate fertilizers for better growth.",
      image: SeedSelectionSowingImage,
    },
    {
      id: 4,
      title: "Irrigation & Water Management",
      description:
        "Adopt smart irrigation techniques to maintain optimal moisture levels.",
      image: PestDiseaseControlImage,
    },
    {
      id: 5,
      title: "Pest & Disease Control",
      description:
        "Implement integrated pest management techniques for a healthy crop.",
      image: HarvestingStorageImage,
    },
    {
      id: 6,
      title: "Harvesting & Storage",
      description:
        "Harvest at the right time and store properly to maintain quality.",
      image: IrrigationWaterManagementImage,
    },
  ];

  // Expert Tips Section Data
  const expertTips = [
    {
      id: 1,
      title: "Tip 1: Proper Soil Testing",
      description:
        "Conduct soil tests before sowing to optimize nutrient levels.",
      icon: "🌱",
    },
    {
      id: 2,
      title: "Tip 2: Crop Rotation Benefits",
      description:
        "Rotate pulse with cereals like maize to improve soil fertility.",
      icon: "🔄",
    },
    {
      id: 3,
      title: "Tip 3: Water Management",
      description:
        "Use drip irrigation to maximize water efficiency and avoid overwatering.",
      icon: "💧",
    },
    {
      id: 4,
      title: "Tip 4: Pest Prevention",
      description:
        "Monitor for early signs of pest damage and use biological control methods.",
      icon: "🐜",
    },
  ];

  return (
    <div className="standard-practices-page">
      {/* Hero Section with Carousel */}
      <section className="carousel-section">
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          navigation={false}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={true}
          className="custom-swiper"
        >
          {carouselData.map((slide, index) => (
            <SwiperSlide key={index}>
              <div
                className="carousel-item"
                style={{ backgroundImage: `url('${slide.image}')` }}
              >
                <div className="overlay">
                  <h2 style={{ color: "white" }}>{slide.title}</h2>
                  <p>{slide.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* Step-by-Step Practices Section */}
      <section className="practices-section container">
        <h2
          className="separator-title"
          style={{ color: "#d4561a" }}
          data-aos="fade-up"
        >
          Standard Package of Practices
        </h2>
        <div className="separator-line mb-5"></div>
        <div className="practices-grid">
          {practices.map((practice) => (
            <div key={practice.id} className="practice-card" data-aos="zoom-in">
              <img
                src={practice.image}
                alt={practice.title}
                className="practice-image"
              />
              <div className="practice-info">
                <h3>{practice.title}</h3>
                <p>{practice.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Expert Tips Section */}
      <section className="expert-tips-section container">
        <h2 className="separator-title" style={{ color: "#d4561a" }}>
          Expert Tips for Better Yield
        </h2>
        <div className="separator-line mb-5"></div>
        <div className="tips-grid">
          {expertTips.map((tip) => (
            <div key={tip.id} className="tip-card" data-aos="fade-up">
              <div className="tip-icon">{tip.icon}</div>
              <h3>{tip.title}</h3>
              <p>{tip.description}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default StandardPractices;
